import React from 'react';
import PropTypes from 'prop-types';

require('./dataset.css');
/**
 * React component used to render the dataset header
 */
class DataCollectionListSummaryTableHeader extends React.Component {
    render() {
        return (
            <thead>
                <tr>
                    <th class='borderedCell' rowSpan={2}>Run</th>
                    <th class='borderedCell' rowSpan={2}>Sample</th>
                    <th class='borderedCell' rowSpan={2}><div> Frames <br /> (avg&nbsp;/&nbsp;tot) </div></th>
                    <th class='borderedCell' colSpan={3}>Guinier</th>
                    <th class='borderedCell' colSpan={3}>Gnom</th>
                    <th class='borderedCell' colSpan={2}>Porod</th>
                    <th class='borderedCell' rowSpan={2}>Scattering</th>
                    <th class='borderedCell' rowSpan={2}>Kratkty</th>
                    <th class='borderedCell' rowSpan={2}>P(r)</th>
                    <th class='borderedCell' rowSpan={2}>Guinier</th>
                    <th class='borderedCell' rowSpan={2}>Advanced</th>
                </tr>
                <tr>
                    <th class='borderedCell'>Rg</th>
                    <th class='borderedCell'>Points</th>
                    <th class='borderedCell'>I0</th>
                    <th class='borderedCell'>Rg</th>
                    <th class='borderedCell'>Total</th>
                    <th class='borderedCell'>D<sub>max</sub></th>
                    <th class='borderedCell'>Volume</th>
                    <th class='borderedCell'>MM. Vol. est.</th>
                </tr>
            </thead>);
    }
}


DataCollectionListSummaryTableHeader.propTypes = {
    /** nothing yet */
}

export default DataCollectionListSummaryTableHeader;


// WEBPACK FOOTER //
// ./src/components/saxs/DataCollection/DataCollectionListSummaryTableHeader.js